<template>
  <div class="about">
    <div><p style="text-align: right;">{{shop}}</p></div>
    <h1>Settings</h1>
    <section v-if="multilocation">
      <p>Multiple locations feature is enabled.</p>
    </section>
    <section v-if="!multilocation && !loading">
      <p>Select a location that you would like to synchronise the inventory quantity</p>
      <h3 v-if="loading || loadingLocation">Loading store locations.. <v-progress-circular :size="15" :width="2" indeterminate color="primary"></v-progress-circular></h3>
      <h3 v-if="!loading && !loadingLocation && location">Location: {{location.shopify_location_name}}</h3>
      <h3 v-if="!loading && !loadingLocation && !location">Location: Not set</h3>
      <p></p>
    </section>

    <section v-if="allLocations && !multilocation">
      <h2>Select a Location</h2>
      <v-data-table
          :headers="headers"
          :items="allLocations"
          hide-actions
          class="elevation-1"
          style="max-width: 500px"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">
              <a v-if="!location || location.shopify_location_id != props.item.id" @click="() => { setLocation(props.item.id, props.item.name) }">Select</a>
              <span v-if="location && location.shopify_location_id == props.item.id">Selected</span>
            </td>
          </template>
        </v-data-table>
    </section>

    <section v-if="syncmaster !== null">
      <v-switch v-model="syncmaster" :label="`Calculate bundle master inventory (every 10 minutes)`" :disabled="settingSyncmaster" @change="setSyncmasterStatus()"></v-switch>
    </section>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  computed: {
    count () {
      return this.$store.state.count
    }
  },
  created: function () {
  },
  data () {
    return {
      shop: this.$store.state.shop,
      info: null,
      loading: true,
      loadingLocation: true,
      location: null,
      allLocations: null,
      syncmaster: null,
      multilocation: null,
      settingSyncmaster: false,
      errored: false,
      headers: [
        {
          text: 'Location',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Action', align: 'right', value: 'id', sortable: false }
      ],
    }
  },
  filters: {
    currencydecimal (value) {
      return value.toFixed(2)
    }
  },
  mounted () {
    axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.$store.getters.code

    this.checkMultiLocationStatus()
    this.checkLocation()

    this.checkSyncmasterStatus()

    let check_all_locations_url = 'https://' + this.$store.getters.engine + '/api/location/search'

    axios
      .get(check_all_locations_url)
      .then(response => {
        this.allLocations = []
        let allLocations = this.allLocations
        let ILVs = []

        response.data.body.data.locations.edges.forEach(function(e){
          allLocations.push(e.node)
          e.node.inventoryLevels.edges.forEach(function(edge){
            let inventoryGID = edge.node.id.split('?')[0].split('/')
            ILVs.push(inventoryGID[inventoryGID.length-1])
          })
        })
        globalStore.inventoryLevels = ILVs
      })
      .catch(error => {
      })
      .finally(() => {
        this.loading = false
      })
  },

  methods : {
    checkMultiLocationStatus () {
      let url = 'https://' + this.$store.getters.engine + '/api/location/status'

      axios
        .get(url)
        .then(response => {
          this.multilocation = (response.data.multilocation === 'enabled')
        })
        .catch(error => {
        })
        .finally(() => {
        })
    },
    checkLocation () {
      let url = 'https://' + this.$store.getters.engine + '/api/location'

      axios
        .get(url)
        .then(response => {
          this.location = response.data
          this.loadingLocation = false
        })
        .catch(error => {
        })
        .finally(() => {
        })
    },
    setLocation (id, name) {
      let url = 'https://' + this.$store.getters.engine + '/api/location'

      axios
        .post(url, {shopify_location_id: id, shopify_location_name: name})
        .then(response => {
        })
        .catch(error => {
        console.log(error)
        })
        .finally(() => {
          this.checkLocation()
        })
    },
    checkSyncmasterStatus () {
      let url = 'https://' + this.$store.getters.engine + '/api/syncmaster/status'

      axios
        .get(url)
        .then(response => {
          this.syncmaster = (response.data.syncmaster === 'enabled')
        })
        .catch(error => {
        })
        .finally(() => {
        })
    },
    setSyncmasterStatus () {
      const status = this.syncmaster
      let url = 'https://' + this.$store.getters.engine + '/api/syncmaster/status'
      this.settingSyncmaster = true
      axios
        .post(url, {syncmaster: status ? 'enabled' : 'disabled'})
        .then(response => {
        })
        .catch(error => {
          this.syncmaster = !status
        })
        .finally(() => {
          this.settingSyncmaster = false
        })
    },
  }

}
</script>
